export default function Welcome() {
  return (
    <section
      id="velkommen"
      data-testid="welcome-section"
      className="relative py-16 sm:py-24 lg:py-32 overflow-hidden"
    >
      {/* Soft pudderrosa/guld background */}
      <div className="absolute inset-0 -z-20 bg-cm-cream" />
      <div
        aria-hidden
        className="absolute inset-0 -z-10"
        style={{
          background:
            "linear-gradient(135deg, rgba(232,199,192,0.35) 0%, rgba(232,220,196,0.25) 50%, rgba(249,246,240,1) 100%)",
        }}
      />
      <div
        aria-hidden
        className="absolute -z-10 left-[-180px] top-[-120px] w-[520px] h-[520px] rounded-full blur-3xl opacity-50"
        style={{ background: "radial-gradient(circle, #E8C7C0 0%, transparent 60%)" }}
      />
      <div
        aria-hidden
        className="absolute -z-10 right-[-200px] bottom-[-160px] w-[560px] h-[560px] rounded-full blur-3xl opacity-40"
        style={{ background: "radial-gradient(circle, #E8DCC4 0%, transparent 60%)" }}
      />
      <div className="grain absolute inset-0 -z-10" />

      <div className="max-w-[920px] mx-auto px-5 sm:px-10 lg:px-16">
        <div className="reveal">
          <span className="ornament" data-testid="welcome-eyebrow">
            <em>Hej</em>
          </span>
          <h2
            data-testid="welcome-headline"
            className="font-serif text-cm-ink mt-8 text-[1.85rem] sm:text-4xl lg:text-[3rem] leading-[1.16] sm:leading-[1.12] tracking-[-0.005em]"
          >
            Velkommen til{" "}
            <span className="marker">CM — Coach &amp; Motivation</span>.
          </h2>

          <div className="mt-10 sm:mt-12 space-y-6 text-cm-ink-soft leading-[1.9] text-base sm:text-[1.0625rem]">
            <p data-testid="welcome-paragraph-1">
              Jeg er coach, fordi jeg oprigtigt brænder for at hjælpe mennesker
              med at finde hjem i sig selv — med mere klarhed, ro og styrke
              indefra. Min tilgang er nærværende, ærlig og helhedsorienteret.
              Jeg ser ikke kun det, du siger med ord, men også det, der ligger
              under overfladen.
            </p>
            <p>
              Som coach møder jeg dig dér, hvor du er. Uden pres. Uden facader.
              Jeg skaber et trygt rum, hvor du kan være dig selv, og hvor der er
              plads til både{" "}
              <span className="text-cm-ink">sårbarhed, refleksion og udvikling</span>
              . Jeg tror på, at du allerede rummer svarene — min opgave er at
              hjælpe dig med at få øje på dem og omsætte dem til handling.
            </p>
            <p>
              Jeg er god til at lytte — virkelig lytte. Jeg stiller de spørgsmål,
              der åbner nye perspektiver, og jeg støtter dig i at mærke efter,
              hvad der er rigtigt for dig, frem for hvad du{" "}
              <em>“burde”</em> gøre. Min styrke ligger i kombinationen af{" "}
              <span className="text-cm-ink">intuition, faglighed og menneskelig forståelse</span>
              .
            </p>
            <p>
              Jeg arbejder ikke med hurtige løsninger, men med varige
              forandringer. For mig handler coaching om mere end mål og
              strategier — det handler om{" "}
              <span className="text-cm-ink">hele mennesket</span>: tanker,
              følelser, krop og livssituation. Når de hænger sammen, skabes
              ægte udvikling.
            </p>
            <p className="font-serif italic text-cm-ink text-lg sm:text-xl leading-relaxed pt-4">
              Hvis du ønsker en coach, der er nærværende, ærlig og engageret i
              din proces — og som går med dig hele vejen — så er jeg her for at
              støtte dig.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
